export default (state = [], action) => {
  switch (action.type) {
    case 'FETCH_PREORDER_MASTER':
      return [ ...state, ...action.payload ] || false
    default:
      return state
  }
}